module.exports = "https://coursera_assets.s3.amazonaws.com/images/7d682b2f7c44af94e35b478c781fe0fd.svg";